import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { QrCode, Copy, ExternalLink } from 'lucide-react';

const SpectatorQrModal = ({ qrSessionId, onClose }) => {
  if (!qrSessionId) return null;
  const url = `${window.location.origin}/spectator/${qrSessionId}`;
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-gray-900 rounded-2xl p-6 border border-cyan-700/30 max-w-md w-full mx-4 shadow-2xl" onClick={e => e.stopPropagation()} data-testid="qr-modal">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-white flex items-center gap-2">
            <QrCode size={20} className="text-cyan-400" />
            Spectator Access
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl">&times;</button>
        </div>
        <div className="bg-white rounded-xl p-4 flex items-center justify-center mb-4">
          <QRCodeSVG value={url} size={200} level="M" data-testid="qr-code" />
        </div>
        <p className="text-sm text-gray-400 text-center mb-3">Scan this QR code to access the live spectator view</p>
        <div className="bg-gray-800 rounded-lg p-3 flex items-center gap-2">
          <input
            readOnly
            value={url}
            className="flex-1 bg-transparent text-cyan-300 text-sm font-mono outline-none"
            data-testid="spectator-url"
          />
          <button
            onClick={() => { navigator.clipboard.writeText(url); }}
            className="text-gray-400 hover:text-white p-1"
            data-testid="copy-url-btn"
            title="Copy URL"
          >
            <Copy size={16} />
          </button>
          <a
            href={`/spectator/${qrSessionId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white p-1"
            data-testid="open-spectator-btn"
            title="Open in new tab"
          >
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SpectatorQrModal;
